module.exports = __webpack_public_path__ + "img/392fb6f.png";